module.exports = __webpack_public_path__ + "static/img/u971.9e10d24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u971.svg
// module id = iSl5
// module chunks = 209